"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hrLocaleData = require("i18next-icu/locale-data/hr");
exports.default = hrLocaleData;
//# sourceMappingURL=hr.js.map